import { computed, makeObservable, observable } from "mobx";
import { GroupUserDto } from "../../../infrastructure/types/group/dto/GroupUserDto";
import { UserRoleDto } from "../../../infrastructure/types/shared/dto/UserRoleDto";
import { getUserDisplayName, getUserInitials } from "../../../utils/userUtils";

export class GroupMember {
  @observable id: string;

  @observable groupId: string;

  @observable groupName: string;

  @observable userId: string;

  @observable userFirstName?: string;

  @observable userLastName?: string;

  @observable userEmail: string;

  @observable role: UserRoleDto;

  constructor(dto: GroupUserDto) {
    makeObservable(this);
    this.id = dto.id;
    this.groupId = dto.groupId;
    this.groupName = dto.groupName;
    this.userId = dto.userId;
    this.userFirstName = dto.userFirstName;
    this.userLastName = dto.userLastName;
    this.userEmail = dto.userEmail;
    this.role = dto.userRole;
  }

  @computed get displayName() {
    return getUserDisplayName(this.userEmail, this.userFirstName, this.userLastName);
  }

  @computed get initials() {
    return getUserInitials(this.userEmail, this.userFirstName, this.userLastName);
  }
}
